import { useEffect, useState } from 'react';

import { Modal, dialogService } from '@thefarmersfront/kitchen';
import { isDeepEqual } from '@thefarmersfront/kitchen-utensil';

import { useShallow } from 'zustand/react/shallow';

import { useProductModalOptions } from '~/hooks/product';
import { PRODUCT_MODAL_INITIAL_VALUE, useProductStore } from '~/store';

import {
  ProductRegisterModalDefaultSection,
  ProductRegisterModalProductInfoSection,
  ProductRegisterModalStockInfoSection,
} from '.';

import type { TypeProductModalInput } from '~/types/product.types';

import styles from './ProductRegisterModal.module.scss';

type TypeProductRegisterModal = {
  open: boolean;
  onCancel: () => void | Promise<void>;
  onConfirm: () => void | Promise<void>;
};

const ProductRegisterModal = ({ open, onCancel, onConfirm }: TypeProductRegisterModal) => {
  const modalOptions = useProductModalOptions();

  const [registerModalValue, setRegisterModalValue] = useProductStore(
    useShallow((state) => [state.productRegisterModalValue, state.setProductRegisterModalValue])
  );

  const [registerModalInitialValue, setRegisterModalInitialValue] =
    useState<TypeProductModalInput>(PRODUCT_MODAL_INITIAL_VALUE);

  const setInitialSelectOptions = () => {
    const initialInputParams = {
      ...registerModalValue,
      shelfLifeType: modalOptions?.shelfLifeType[0] ?? registerModalValue.shelfLifeType,
      unit: modalOptions?.unit[0] ?? registerModalValue.unit,
      productType: modalOptions?.productOperationType[0] ?? registerModalValue.productType,
      packingDirection: modalOptions?.packingDirection[0] ?? registerModalValue.packingDirection,
    };

    setRegisterModalValue(initialInputParams);
    setRegisterModalInitialValue(initialInputParams);
  };

  useEffect(() => {
    setInitialSelectOptions();
  }, []);

  const handleClickCancelButton = () => {
    const isInputChanged = !isDeepEqual(registerModalValue, registerModalInitialValue);

    if (!isInputChanged) {
      onCancel();

      return;
    }

    dialogService.addDialog({
      children: (
        <>
          작성된 내용이 저장되지 않습니다.
          <br />
          페이지를 나가시겠습니까?
        </>
      ),
      open: true,
      type: 'confirm',
      cancelText: '취소',
      confirmText: '나가기',
      onConfirm: onCancel,
    });
  };

  return (
    <Modal
      open={open}
      title="상품 등록"
      confirmText="등록"
      size="xlarge"
      onCancel={handleClickCancelButton}
      onConfirm={onConfirm}
    >
      <div className={styles['product-register-modal']}>
        <ProductRegisterModalDefaultSection />
        <ProductRegisterModalProductInfoSection />
        <ProductRegisterModalStockInfoSection />
      </div>
    </Modal>
  );
};

export default ProductRegisterModal;
